import { render, staticRenderFns } from "./PublisherSetupTabCurrency.vue?vue&type=template&id=5d5ae878"
import script from "./PublisherSetupTabCurrency.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports